import { Link } from "react-router-dom";
import { contacts, locations } from "@/mocks/site-data";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-18">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <img
              src="https://storage.helloreaddy.io/project_files/6df48b80-c75c-4832-be6c-52c7656ae481/9ba7cdbd-4cc3-4b34-9d07-828f7801dc96_compressed_base_logo_transparent_background-1.webp"
              alt="REDENET"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              Comércio e Soluções em TI. Desenvolvemos softwares inovadores para transformar a educação no Brasil.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-5 font-heading uppercase tracking-wide">
              Links Rápidos
            </h4>
            <ul className="flex flex-col gap-3">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/produtos" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Produtos
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Contato
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-5 font-heading uppercase tracking-wide">
              Produtos
            </h4>
            <ul className="flex flex-col gap-3">
              <li>
                <a href="https://www.iescolaronline.com.br" target="_blank" rel="noopener noreferrer" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  IE - iEscolar Online
                </a>
              </li>
              <li>
                <a href="https://www.rface.com.br" target="_blank" rel="noopener noreferrer" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  RFACE
                </a>
              </li>
              <li>
                <a href="https://www.iluminia.com.br" target="_blank" rel="noopener noreferrer" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  iLuminIA
                </a>
              </li>
              <li>
                <a href="https://www.saecta.com.br" target="_blank" rel="noopener noreferrer" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  SAECTA
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-5 font-heading uppercase tracking-wide">
              Contato
            </h4>
            <ul className="flex flex-col gap-3">
              {contacts.emails.map((email) => (
                <li key={email.value}>
                  <a
                    href={`mailto:${email.value}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors break-all"
                  >
                    {email.value}
                  </a>
                </li>
              ))}
              {contacts.phones.map((phone) => (
                <li key={phone.value}>
                  <a
                    href={phone.type === "whatsapp" ? `https://wa.me/55${phone.value.replace(/\D/g, "")}` : `tel:${phone.value.replace(/\D/g, "")}`}
                    target={phone.type === "whatsapp" ? "_blank" : undefined}
                    rel={phone.type === "whatsapp" ? "noopener noreferrer" : undefined}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {phone.type === "whatsapp" && (
                      <i className="ri-whatsapp-line mr-1" />
                    )}
                    {phone.value}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              © {currentYear} REDENET Comércio Soluções em TI. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-3 text-xs text-foreground-500">
              {locations.map((loc) => (
                <span key={loc.id} className="px-2 py-1 rounded-full bg-background-200/50">
                  {loc.city} - {loc.state}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}